export enum SLUGS {
  CAMPUS_UL = 'campus-ul',
  CENTRE_EXAMEN = 'centre',
  REPONDANT = 'repondant'
}

export default interface ITypeInscriptionLieuExamen {
  abreviation: string;
  createdAt: string;
  createdBy: string;
  createdByFullName: string;
  description: string;
  id: number;
  isActif: boolean;
  nom: string;
  slug: string;
  updatedAt: string;
  updatedBy: string;
  updatedByFullName: string;
  version: number;
}